module.exports = __webpack_public_path__ + "static/media/change_tyre.3ff5fea6.svg";